<script setup lang="ts">
import { useTranslation } from '@hfc/ui-core';

withDefaults(defineProps<{
  showTitle?: boolean;
  showShadow?: boolean;
}>(), {
  showTitle: true,
  showShadow: true,
});

const { t } = useTranslation();
</script>
<template>
  <div class="flex flex-col items-center whitespace-normal">
    <div v-if="showTitle" class="py-10">
      <h1 class="text-center">{{ t('feedback.title') }}</h1>
    </div>
    <div class="flex flex-col w-full bg-white rounded-lg p-4 sm:p-6 lg:w-[500px]" :class="{ 'shadow-lg': showShadow }">
      <div class="flex flex-col space-y-4">
        <h2 class="font-semibold">{{ t('feedback.thankYou.heading') }}</h2>
        <span>{{ t('feedback.thankYou.supportResponse') }}</span>
        <span class="font-semibold">{{ t('feedback.thankYou.changesNote') }}</span>
        <span v-html="t('feedback.thankYou.changesDetail')"></span>
        <span v-html="t('feedback.thankYou.priorityLine')"></span>
      </div>
    </div>
  </div>
</template>
